<!-- <a *ngIf="!isFromSM">
<button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPVIEWUSERINFO'] | translate}}" [routerLink]="routerLinkViewUser">Benutzerinformation</button>
</a> -->

<a>
  <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPVIEWUSERINFO'] | translate}}" [routerLink]="routerLinkViewUser">Benutzerinformation</button>
</a>

<a>
  <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPREMOVEUSER'] | translate}}" (click)="deleteUser()">Entfernen</button>
</a>
@if (rowUserData[0] != undefined && !rowUserData[0].lockoutEnabled && !(rowUserData[0].emailConfirmed === false && isOutOfDate(rowUserData[0].invitationDueDate))) {
  <a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="Für diesen Mandanten sperren" (click)="lockUser()">Sperren</button>
  </a>
}
@if (rowUserData[0] != undefined && rowUserData[0].lockoutEnabled) {
  <a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="Für diesen Mandanten entsperren" (click)="unlockUser()">Entsperren</button>
  </a>
}
@if (rowUserData[0] != undefined && rowUserData[0].emailConfirmed === false && isOutOfDate(rowUserData[0].invitationDueDate)) {
  <a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="Benutzer erneut einladen" (click)="resendInvitation()">Erneut einladen</button>
  </a>
}
<!-- <a *ngIf="rowUserData[0] != undefined && rowUserData[0].lockoutEnabled">
<span class="material-symbols-outlined" style="margin-left: -70px;">
  <mat-icon matTooltip="Benutzer ist für diesen Mandanten gesperrt" (click)="unlockUser()">lock</mat-icon>
</span>
</a> -->
